import React from "react"
import "twin.macro"
import { useTranslation } from "next-i18next"
import Link from "next/link"
import { Routes } from "../../routes"

interface ZeroStateProps {
  isUser: boolean
}
export const QuestionsZeroState = ({ isUser }: ZeroStateProps) => {
  const { t } = useTranslation("profile")
  return (
    <>
      {isUser ? (
        <p tw="text-center" data-testid="zero-state-questions">
          {t("questions.empty_personal")}
        </p>
      ) : (
        <p tw="text-center" data-testid="zero-state-questions">
          {t("questions.empty")}
          <br />
          <Link href={Routes.FaqAudiogram} passHref scroll={false}>
            <span tw="underline cursor-pointer">{t("learn_more")}</span>
          </Link>
        </p>
      )}
    </>
  )
}
export const AnswersZeroState = ({ isUser }: ZeroStateProps) => {
  const { t } = useTranslation("profile")

  return (
    <>
      {isUser ? (
        <p tw="text-center" data-testid="zero-state-answers">
          {t("answers.empty_personal")}
        </p>
      ) : (
        <p tw="text-center" data-testid="zero-state-answers">
          {t("answers.empty")}
          <br />
          <Link href={Routes.FaqAudiogram} passHref scroll={false}>
            <span tw="underline cursor-pointer">{t("learn_more")}</span>
          </Link>
        </p>
      )}
    </>
  )
}
